<template>
  <div class="split-account-wrapper">

    <custom-table
      :data="splitAccountList"
      @data-change="updateTableData"
      v-if="hasRes('split_account_index')"
      :fetch="true">

      <el-table-column
        prop="split_account_id"
        label="分账规则 ID"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="userid"
        label="商户名（主账户）"
        align="center"
        header-align="center"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tooltip placement="top" v-if="scope.row.users.length > 0">
            <div slot="content">
              商户ID: {{ scope.row.users[0].userid }} <br/>
              商户昵称: {{ scope.row.users[0].alias || '未设置' }}
            </div>
            <span>
              {{ scope.row.users[0].username }}
            </span>
          </el-tooltip>
          <span v-else> 未绑定 </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="merchant_id"
        label="收款账户 ID（主账户）"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="app_id"
        label="渠道 APPID（主账户）"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ scope.row.app_id || '无' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="acct_name"
        label="收款人（主账户）"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="acct_no_encry"
        label="银行卡号（主账户）"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="split_percent"
        label="分账比例（主账户）"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ scope.row.split_percent }}%
        </template>
      </el-table-column>

      <el-table-column
        prop="now_pay_channel"
        label="支付渠道"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ getPayChannel(scope.row.now_pay_channel) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="split_account"
        label="分账信息"
        sortable="custom"
        align="center"
        header-align="center" >

        <template slot-scope="scope">
          <span v-if="scope.row.split_account.length > 0">
            {{ getSplitAccountDesc(scope.row) }}
          </span>
          <br/>
          <el-popover
            placement="top"
            width="700">
            <el-table
              :data="scope.row.split_account"
              size="small" >
              <el-table-column property="merchant_id" label="收款账户ID（子账户）" align="center" header-align="center"></el-table-column>
              <el-table-column property="acct_no_encry" label="银行卡（子账户）" align="center" header-align="center"></el-table-column>
              <el-table-column property="acct_name" label="收款人（子账户）" align="center" header-align="center"></el-table-column>
              <el-table-column property="split_percent" label="分账比例（子账户）" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.split_percent }}%</span>
                </template>
              </el-table-column>
              <el-table-column property="email" label="邮箱（子账户）" align="center" header-align="center"></el-table-column>
              <el-table-column property="app_id" label="支付渠道商户ID（子账户）" align="center" header-align="center"></el-table-column>
            </el-table>
            <span class="split-account-more" slot="reference">分账详情</span>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        prop="apply_rules"
        label="申请模板"
        sortable="custom"
        align="center"
        header-align="center" >

        <template slot-scope="scope">
          <span v-if="scope.row.apply_rule.length > 0">
            {{ getApplyRuleDesc(scope.row) }}
          </span>
          <br>
          <el-popover
            placement="top"
            width="400">
            <el-table
              :data="scope.row.apply_rule"
              size="small" >
              <el-table-column property="account" label="账号类型" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.account === 'main_account' ? '主账号' : '子账号' }}</span>
                </template>
              </el-table-column>
              <el-table-column property="split_percent" label="分账比例" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.split_percent }}%</span>
                </template>
              </el-table-column>
            </el-table>
            <span class="split-account-more" slot="reference">模板详情</span>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        prop="apply_type"
        label="申请类型"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.apply_type === 0 ? 'warning' : 'info' "
            size="mini">
            {{ scope.row.apply_type === 0 ? '新增' : '修改' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="审核状态"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status === 0 ? 'warning' : 'success' "
            size="mini">
            {{ scope.row.status === 0 ? '审核中' : '审核通过' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="create_at"
        label="创建时间"
        sortable="custom"
        align="center"
        header-align="center" >
        <template slot-scope="scope">
          {{ scope.row.create_at | dateformat }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        v-if="hasRes('split_account_pass')"
        width="100" >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            :disabled="scope.row.status === 1"
            @click="onReview(scope)" >审核</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="splitAccountCount"
      v-if="hasRes('split_account_index')"
      @page-change="updateTableData" />

    <dialog-split-account-review
      :visible.sync="splitAccountReviewDialogVisible"
      :reviewingAccount="reviewingAccount"
      v-if="hasRes('split_account_pass')"
      @data-change="updateTableData" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import DialogSplitAccountReview from '@/components/bank/DialogSplitAccountReview'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'SplitAccount',
  components: {
    CustomTable,
    CustomPaginate,
    DialogSplitAccountReview
  },
  data () {
    return {
      payChannelList: {
        'sb': '扫呗',
        'jd': '京东'
      },

      splitAccountReviewDialogVisible: false,
      reviewingAccount: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters'
    ]),
    ...mapState('bank', [
      'splitAccountList',
      'splitAccountCount'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING,
      SET_FILTERS
    ]),
    ...mapActions('bank', [
      'getSplitAccounts'
    ]),

    getPayChannel (tag) {
      if (tag in this.payChannelList) {
        return this.payChannelList[tag]
      }
      return '未知'
    },
    getSplitAccountDesc (row) {
      const len = row.split_account.length
      if (len <= 0) {
        return '无'
      } else if (len <= 3) {
        var desc = ''
        for (let i = 0; i < len; i++) {
          if (i === len - 1) {
            desc += `${row.split_account[i].split_percent}%`
          } else {
            desc += `${row.split_account[i].split_percent}%, `
          }
        }
        return desc
      } else if (len > 3) {
        return `${row.split_account[0].split_percent}%,${row.split_account[1].split_percent}%...`
      }
    },
    getApplyRuleDesc (row) {
      const len = row.apply_rule.length
      if (len <= 0) {
        return '无'
      } else if (len <= 3) {
        var desc = ''
        for (let i = 0; i < len; i++) {
          if (i === len - 1) {
            desc += `${row.apply_rule[i].split_percent}%`
          } else {
            desc += `${row.apply_rule[i].split_percent}%, `
          }
        }
        return desc
      } else if (len > 3) {
        return `${row.apply_rule[0].split_percent}%, 
          ${row.apply_rule[1].split_percent}%, ${row.apply_rule[2].split_percent}%...`
      }
    },

    onReview (scope) {
      this.reviewingAccount = scope.row
      this.splitAccountReviewDialogVisible = true
    },

    updateTableData () {
      this.setLoading(true)

      this.getSplitAccounts({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取分账列表失败'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.split-account-wrapper {
  .split-account-more {
    cursor: pointer;
    font-size: 10px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/bank/SplitAccount.vue